module.exports = __webpack_public_path__ + "static/img/project_logo_lastingimpressions.37ccec9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project_logo_lastingimpressions.svg
// module id = 750
// module chunks = 1